module.exports = __webpack_public_path__ + "assets/img/contact.a8001194.png";